module.exports = __webpack_public_path__ + "static/media/Roadcome.eab74d48.png";